/**
 * @description editor 插件，重写 editor API
 */
import {
  SlateEditor,
  SlateTransforms,
  SlatePoint,
  SlateNode,
  DomEditor,
} from "@wangeditor/editor";
import { ELEMENT_TYPE } from "./constants";
import { Editor, Transforms } from "slate";

function withMarkBlock(editor) {
  const { insertBreak, insertText, deleteBackward, normalizeNode } = editor;
  const newEditor = editor;
  // 重新 normalize
  newEditor.normalizeNode = ([node, path]) => {
    const type = DomEditor.getNodeType(node);
    if (type !== ELEMENT_TYPE) {
      // 未命中  执行默认的 normalizeNode
      return normalizeNode([node, path]);
    }

    // --------------   是 editor 最后一个节点，需要后面插入 p --------------
    const isLast = DomEditor.isLastNode(newEditor, node);
    if (isLast) {
      Transforms.insertNodes(newEditor, DomEditor.genEmptyParagraph(), {
        at: [path[0] + 1],
      });
    }
  };
  // 重写删除
  newEditor.deleteBackward = (unit) => {
    const selection = editor.selection;
    if (selection == null) return deleteBackward(unit);
    const [nodeEntry] = SlateEditor.nodes(editor, {
      match: (n) => DomEditor.checkNodeType(n, ELEMENT_TYPE),
      universal: true,
    });
    if (!nodeEntry) return deleteBackward(unit);
    const quoteElem = nodeEntry[0];
    const quotePath = DomEditor.findPath(editor, quoteElem);
    const quoteStartLocation = SlateEditor.start(editor, quotePath);
    if (SlatePoint.equals(quoteStartLocation, selection.focus)) {
      // // 光标位于 元素的 最开始
      return;
    } else {
      deleteBackward(unit);
    }
  };

  // 重写 insertText
  newEditor.insertText = (text) => {
    const { selection } = newEditor;
    if (selection == null) return insertText(text);

    const [nodeEntry] = SlateEditor.nodes(editor, {
      match: (n) => DomEditor.checkNodeType(n, ELEMENT_TYPE),
      universal: true,
    });
    if (!nodeEntry) return insertText(text);
    // 限制文本长度
    // 获取当前类型输入的文字
    const quoteElem = nodeEntry[0];
    const quotePath = DomEditor.findPath(editor, quoteElem);
    const str = SlateNode.string(quoteElem);
    const textStr = String(text);
    const couldInsertLength = 10 - str.length;
    const couldInsertStr = textStr.slice(0, couldInsertLength);
    if (couldInsertLength < 0) {
      // 限制输入
      // const newSeletion = {
      //   focus: {
      //     path: quotePath,
      //     offset: 11,
      //   },
      //   anchor: {
      //     path: quotePath,
      //     offset: 11,
      //   },
      // };
      console.log("小于0");
      // console.log(newSeletion);
      // SlateTransforms.delete(editor, newSeletion);
      editor.deleteBackward();
    } else if (couldInsertLength === 0) {
      // 把当前文本替换
      SlateTransforms.insertText(editor, " ", {
        at: selection,
      });
      return false;
    } else {
      return insertText(couldInsertStr);
    }
  };

  // 重写 insertBreak - 换行时插入 p
  newEditor.insertBreak = () => {
    const { selection } = newEditor;
    if (selection == null) return insertBreak();

    const [nodeEntry] = SlateEditor.nodes(editor, {
      match: (n) => DomEditor.checkNodeType(n, ELEMENT_TYPE),
      universal: true,
    });
    if (!nodeEntry) return insertBreak();

    const quoteElem = nodeEntry[0];
    const quotePath = DomEditor.findPath(editor, quoteElem);
    const quoteEndLocation = SlateEditor.end(editor, quotePath);
    if (SlatePoint.equals(quoteEndLocation, selection.focus)) {
      // 光标位于 元素的 最后
      const str = SlateNode.string(quoteElem);
      // if (str && str.slice(-1) === '\n') {
      // blockquote 文本最后一个是 \n，就跳出边距节点
      editor.deleteBackward("character"); // 删除最后一个 \n
      // 则插入一个 paragraph
      const p = { type: "paragraph", children: [{ text: "" }] };
      SlateTransforms.insertNodes(newEditor, p, { mode: "highest" });
      return;
      // }
    } else {
      // 禁止换行
      return;
    }
  };
  // 重新粘贴
  // newEditor.insertData = (data) => {
  //   console.log("insertData", data);
  // };

  return newEditor;
}
export default withMarkBlock;
